export default {
	addNetwork: 'Add a Network',
	editNetwork: 'Edit a Network',
	networkName: 'Network Name',
	networkNameLabel: 'Network',
}
